angular.module('webcomm')
    .directive('activity', function() {
        return {
            scope: {
                //items: '='
            },
            templateUrl: 'app/main/activity/activity.html',
            replace: true,
            controller: 'ActivityController',
            controllerAs: 'activity'
        };
    })
    .controller('ActivityController', [
        'activityService', 'channelModel', function (activityService, channelModel) {
            this.isVisible = false;
            this.toggle = ($event) => {
                if (this.activities.length > 0) {
                    this.isVisible = !this.isVisible;
                    activityService.setVisible(this.isVisible);
                }
            }

            this.selectChannel = (channelId) => {
                if(channelId !== 0) {
                    channelModel.selectChannel(channelId);
                }
            }

            this.newActivityCount = activityService.newActivityCount;
            this.activities = activityService.activities;
        }
    ]);